<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Code of Ethics</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Code of Ethics</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="calender ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Principal</h4>
            <a href="https://urlzs.com/ZXqLu" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Governing Body</h4>
            <a href="https://urlzs.com/rqTrC" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Faculty</h4>
            <a href="https://urlzs.com/AGhvS" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="pdfBox">
          <div class="pdf-icon">
            <span><i class="fa fa-file-pdf-o"></i></span>
          </div>
          <div class="pdf-content">
            <h4>Student</h4>
            <a href="https://urlzs.com/rNU6x" class="cmn-button" target="_blank">Click Here</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
